import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function Category({
  id,
  name,
  thumbnail,
  activity_types,
  isOpened,
  handleClick,
  handleOpen,
}) {
  const navigate = useNavigate();
  const { activityTypes } = useSelector((state) => state.activityTypes);

// handleClick(null, type)
  return (
    <div className={isOpened ? "category_item active" : "category_item"}>
      <div
        className="category_item_wrapper"
        onClick={() => (isOpened ? handleOpen(null) : handleOpen(id))}
      >
        <div className="category-name">{name}</div>
        <div className="d-flex align-items-center">
          <div>
            <img src={thumbnail} className="category-image" />
          </div>
          <div className="down-btn">
            <img src="/assets/icons/down.svg" />
          </div>
        </div>
      </div>
      {isOpened && (
        <div className="types">
          {activityTypes.map((type) =>
            type.activity_category_id === id ? (
              <div
                key={type.id}
                className="type"
                onClick={() =>
                  navigate(`/design?selectedActivityId=${type.id}`)
                }
              >
                {" "}
                {type.name}{" "}
              </div>
            ) : (
              ""
            )
          )}
        </div>
      )}
    </div>
  );
}

